import * as React from 'react';

const ArrowBack = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <mask
      id="mask0_15384_9753"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_15384_9753)">
      <path
        d="M10.6667 14.6668L4 8.00016L10.6667 1.3335L11.85 2.51683L6.36667 8.00016L11.85 13.4835L10.6667 14.6668Z"
        fill="#979797"
      />
    </g>
  </svg>
);
export default ArrowBack;
